export default {"src":"/_next/static/media/white-logo.55678da9.svg","height":74,"width":177};